import React from 'react';

import { EmailConfirmation } from '@/modules/user';

const EmailConfirmationPage = () => (
  <EmailConfirmation />
);
export default EmailConfirmationPage;
